<div *ngIf="purchasedItem; else noItem">
  <!-- Not Redeemed / expired -->
  @if (!purchasedItem?.RedeemDate && !expired()) {
    <div class="marketplace-wallet-item-list">
      <ng-container *ifScreenSize="screenType.Desktop">
        <ng-container *ngTemplateOutlet="carouselWallet; context: { $implicit: desktopOptions, width: 0 }"></ng-container>
      </ng-container>
      <ng-container *ifScreenSize="screenType.Mobile">
        @if (groupedItem?.count > 1) {
          <ng-container *ngTemplateOutlet="carouselWallet; context: { $implicit: mobileOptions, width: 305 }"></ng-container>
        } @else {
          <div class="single-wallet">
            <fgbcl-rewards-wallet-redeem-list-item
              [item]="purchasedItem"
              [multi]="false"
              [showButton]="false"
              orientation="landscape"
            ></fgbcl-rewards-wallet-redeem-list-item>
          </div>
        }
      </ng-container>
    </div>
  } @else {
    <!-- Redeemed view -->
    <fgbcl-rewards-wallet-redeem-list-item
      [item]="purchasedItem"
      [multi]="false"
      orientation="landscape"
    ></fgbcl-rewards-wallet-redeem-list-item>
  }

  <div class="loyalty-details w-100 mt-4">
    <!-- Details -->
    <h5 class="item-details-title">{{ 'lottos.wallet.details.item.title' | translate }}</h5>

    <div class="wallet-details-container">
      <!-- Custom Field -->
      <ng-container *ngIf="customFields && customFields.length">
        <div class="wallet-details-item wallet-custom-fields" *ngFor="let customField of customFields; let i = index">
          <div class="wallet-details-item-label">{{ customField.DisplayName }}</div>
          @if (customField.isDate) {
            <div class="wallet-details-item-value">
              {{ customField.DisplayValue | UtcToLocaltimePipe: dateOption?.NgbDateFormat }}
            </div>
          } @else {
            <span class="wallet-details-item-value">{{ customField.DisplayValue }}</span>
          }
        </div>
      </ng-container>
      <!-- Quantity -->
      @if (groupedItem?.count > 1 && !purchasedItem?.RedeemDate && !expired) {
        <div class="wallet-details-item wallet-quantity">
          <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.quantity' | translate }}</div>
          <div class="wallet-details-item-value">
            {{ groupedItem?.count }}
          </div>
        </div>
        <div class="wallet-details-item wallet-points-value">
          <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.points' | translate }}</div>

          @if (totalPoints > 0) {
            <div class="wallet-details-item-value">
              {{ totalPoints | FortressCurrencyPipe: 'PTS' }}
            </div>
          } @else {
            <div class="wallet-details-item-value">
              {{ 'fgbcl.lottos.item.free' | translate }}
            </div>
          }
        </div>
      } @else {
        <div class="wallet-details-item wallet-points-value">
          <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.points' | translate }}</div>

          @if (purchasedItem?.PointValue > 0) {
            <div class="wallet-details-item-value">
              {{ purchasedItem?.PointValue | FortressCurrencyPipe: 'PTS' }}
            </div>
          } @else {
            <div class="wallet-details-item-value">
              {{ 'fgbcl.lottos.item.free' | translate }}
            </div>
          }
        </div>
      }
    </div>

    <!-- Card Body -->
    <div class="accordion accordion-flush" id="marketplace-wallet-accordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="accordion-desc-heading">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#accordion-desc"
            aria-expanded="true"
            aria-controls="accordion-desc"
          >
            {{ 'fgbcl.rewards.wallet.description' | translate }}
          </button>
        </h2>
        <div id="accordion-desc" class="accordion-collapse collapse show" aria-labelledby="accordion-desc-heading">
          <div class="accordion-body">
            <fgbcl-short-long-description [description]="purchasedItem.Description"> </fgbcl-short-long-description>
          </div>
        </div>
      </div>

      <!--Terms-->
      <ng-container *ngIf="purchasedItem.TermsAndConditions">
        <div class="accordion-item">
          <h2 class="accordion-header" id="accordion-terms-heading">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion-terms"
              aria-expanded="false"
              aria-controls="accordion-terms"
            >
              {{ 'fgbcl.rewards.wallet.terms' | translate }}
            </button>
          </h2>
          <div id="accordion-terms" class="accordion-collapse collapse" aria-labelledby="accordion-terms-heading">
            <div class="accordion-body">
              <fgbcl-short-long-description [description]="purchasedItem.TermsAndConditions"> </fgbcl-short-long-description>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noItem>
  <div class="text-center m-5">
    <i>{{ 'wallet.no.items.found' | translate }}</i>
  </div>
</ng-template>

<ng-template #carouselWallet let-options let-width="width">
  <owl-carousel-o [options]="options">
    <ng-container *ngFor="let data of groupedItem?.items">
      <ng-template carouselSlide [width]="width">
        <fgbcl-rewards-wallet-redeem-list-item
          [item]="data"
          [multi]="false"
          [showButton]="false"
          orientation="landscape"
        ></fgbcl-rewards-wallet-redeem-list-item>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</ng-template>
